import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    networkStatsUserId: null as null|string
  }),
  watch: {
    networkStatsUserId: {
      handler (newVal: null|string, oldVal: null|string|undefined) {
        if (oldVal !== null && oldVal !== undefined) this.$store.direct.dispatch.networkStats.unsubscribeUserStats(oldVal)
        if (newVal !== null) this.$store.direct.dispatch.networkStats.subscribeUserStats(newVal)
      },
      immediate: true
    }
  },
  beforeDestroy () {
    if (this.networkStatsUserId !== null) {
      this.$store.direct.dispatch.networkStats.unsubscribeUserStats(this.networkStatsUserId)
    }
  }
})
